import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaArrowUp } from 'react-icons/fa'; // මේකට react-icons install කරලා තිබිය යුතුයි

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // සයිට් එකේ pixel 300ක් පහළට ගියහම Button එක පෙන්වන්න
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5, y: 50 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 50 }}
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-[50] bg-brand-red text-white p-4 rounded-full shadow-2xl hover:bg-brand-blue transition-colors duration-300 group"
          aria-label="Back to top"
        >
          <FaArrowUp className="w-5 h-5 group-hover:-translate-y-1 transition-transform duration-300" />
          
          {/* පොඩි Hover Effect එකක් - "Top" කියලා වැටෙන්න */}
          <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-brand-blue text-white text-[10px] py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity">
            TOP
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;